import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.GdprActionsRestService
 *
 * @description
 * This class contains methods used for GDPR actions
*/
export default class GdprActionsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /*
    * @name rest.services.GdprActionsRestService#getAllAsync
    * @methodOf rest.services.GdprActionsRestService
    * @function
    *
    * @description
    * Makes a get request to the gdpr-actions endpoint to get all actions
    *
    * @param {object} payload gdpr payload
    *
    * @returns {Promise} The promise of the call.
    */
    getAllAsync() {

        return super.getAllAsync('gdpr-actions/');

    }

    /**
     * @ngdoc function

     /**
      * @ngdoc function
      * @name rest.services.GdprActionsRestService#deploy
      * @methodOf rest.services.GdprActionsRestService
      * @function
      *
      * @description
      * Makes the call to the gdpr-actions endpoint delete account or get report
      *
      * @param {object} payload gdpr payload
      *
      * @returns {Promise} The promise of the call.
      */
    create(payload) {

        return super.create(payload, 'gdpr-actions/');

    }

}

_serviceDependencies.push(GdprActionsRestService);

angular.module('rest.services')
    .service('GdprActionsRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/gdprActionsRestService.js